import axios from 'axios'

export default {
  // ======================================================================
  // ==========================List Management=============================
  // ======================================================================
  icfusionendpointList (context, opts) {
    if (!context.state.fetchingList) {
      context.commit('ICFUSIONENDPOINT_FETCHING_LIST', true)
      return new Promise((resolve, reject) => {
        axios
          .get('/api/icfusionendpoint', { params: opts })
          .then(({ data }) => {
            context.commit('ICFUSIONENDPOINT_LIST', data)
            resolve(data)
          })
          .catch((error) => reject(error))
          .finally(() => context.commit('ICFUSIONENDPOINT_FETCHING_LIST', false))
      })
    }
  },
  icfusionendpointUpdated (context, opts) {
    const current = (context.rootState.Organization.current.id === opts.organization)
    if (opts.socket && current) {
      const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
      const inputs = { }
      if (opts && Array.isArray(opts.populate) && opts.populate.length > 0) {
        inputs.params = { }
        inputs.params.populate = opts.populate
      }
      const inList = context.state.list.find((i) => i.id === id)
      if (context.state.current.id === id || inList) {
        axios
          .get(`/api/icfusionendpoint/${id}`, inputs)
          .then(({ data }) => {
            if (data.id === context.state.current.id) {
              context.commit('ICFUSIONENDPOINT_CURRENT', data)
            }
            if (inList) {
              context.commit('ICFUSIONENDPOINT_LIST_UPDATE', data)
            }
          }).catch(() => {
          })
      }
    }
  },
  icfusionendpointDestroyed (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    if (id === context.state.current.id) {
      context.commit('ICFUSIONENDPOINT_CURRENT', null)
    }
    context.commit('ICFUSIONENDPOINT_LIST_ITEM_REMOVE', opts)
  },
  // ======================================================================
  // ==========================Item Management=============================
  // ======================================================================
  icfusionendpointDetail (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    const inputs = { }
    if (opts && Array.isArray(opts.populate) && opts.populate.length > 0) {
      inputs.params = { }
      inputs.params.populate = opts.populate
    }
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/icfusionendpoint/${id}`, inputs)
        .then(({ data }) => {
          context.commit('ICFUSIONENDPOINT_CURRENT', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  icfusionendpointUpdate (context, opts) {
    const updates = Object.assign({}, context.state.update)
    for (const key of Object.keys(updates)) {
      if ((updates[key] === null || updates[key] === context.state.current[key]) && key !== 'id') {
        delete updates[key]
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/icfusionendpoint/${context.state.current.id}`, updates)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  }
}
